import { QRFC } from "./QRFC";

export class QSvrPersonQuery extends QRFC {
  constructor() {
    super();
  }

  InitServerPersonQuery(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qquerysvrperson";
  }

  SetParams(orgName, username, query, planID, chartID, handlePositions, getHoldersWithNoPosition) {
    this.AddEncodedParameter("planID", planID);
    this.AddEncodedParameter("chartID", chartID);
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", username);
    this.AddEncodedParameter("query", JSON.stringify(query));
    this.AddEncodedParameter("handlePositions", handlePositions);
    this.AddEncodedParameter("getHoldersWithNoPosition", getHoldersWithNoPosition);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];

    callBackObj.SvrQueryResult(success, r);
  }
}
